export default __webpack_public_path__ + "static/media/logo-DiabetesCentre.30041c2b.jpg";